import { useState } from 'preact/hooks';
import { createPortal } from 'preact/compat';
import { useQuery }	from '@apollo/client';
import useLocalStorageState from "use-local-storage-state";
import PRODUCT_QUERY from '@/queries/productQuery';
import PRODUCT_AVAILABLE_QUERY from '@/queries/productAvailabilityQuery';
import AddToCartButton from '@/components/AddToCartButton';

function FeaturedProduct({ productId, enterpriseProductId, target }) {
	const [currentProductId, setCurrentProductId] = useState(productId);
	const [status, setStatus] = useState('loading');
	const [otherRetailerStatus, setOtherRetailerStatus] = useState('loading');
	if ( !target ) {
		return null;
	}

	const [retailerObject, setRetailerObject] = useLocalStorageState("dutchie_retailer");
	const retailerId = retailerObject?.id;
	const retailer = dutchie.retailers.find(
		(location) => location.id === retailerObject?.id
	);
	
	const { loading, error, data } = useQuery(PRODUCT_QUERY, {
		variables: {
			productId: currentProductId,
			retailerId: retailerId
		},
		onCompleted: (data) => {
			setStatus('done');
		},
		onError: (error) => {
			setStatus('error');
		}
	});

	const { loading: otherRetailersLoading, error: otherRetailerError, data: otherRetailersData } = useQuery(PRODUCT_AVAILABLE_QUERY, {
		variables: {
			enterpriseProductId: enterpriseProductId,
			retailerId: retailerId
		},
		skip: error ? false : true, // Only run this query if the first one fails
		onCompleted() {
			setOtherRetailerStatus('complete');
		}
	});

	let content = <h3>Loading...</h3>; // Default content

	function setDutchieRetailerAndProduct(retailer, productId) {
		const newLocation = dutchie.retailers.find((item) => { return item.id === retailer.id });
		setRetailerObject(newLocation);
		setCurrentProductId(productId);
	}

	if ( data?.product ) {
		content = (
			<AddToCartButton product={data.product} quantity={1} classes="btn-primary">
				<AddToCartButton.Label>Add to Cart</AddToCartButton.Label>
			</AddToCartButton>
		);
	} else if (status=== 'error') {
		content = (
			<div className="other-retailers">
				{otherRetailersData?.productAvailabilityByRetailer?.some(item => item.isAvailable) ? (
					<>
						<h3>Switch your Store to Shop</h3>
						<p>This product is available at the following locations</p>
						<div className="featured-product-retailers">
						{otherRetailersData?.productAvailabilityByRetailer?.map((item, index) => {
							if ( !item.isAvailable ) {
								return null;
							}
							return (
								<button 
								key={index} className="btn-sm btn-primary-outline" 
								onClick={() => setDutchieRetailerAndProduct(item.retailer, item.productId)}
								>
									{item.retailer.name}
								</button>
							);
						})}
						</div>
					</>
				) : !loading && otherRetailerStatus === 'complete' ? (
					<p>😔 This product is currently not available at any of our retailers.</p>
				) : null }
			</div>
		);
	}

	return createPortal(
		content,
		target
	);
}
export default FeaturedProduct;